import React, { useRef } from "react";
import { SwitchTransition, Transition } from "react-transition-group";
import _ from "lodash";

const zwoopOffset = 5;

const calculateHeight = (childrenRef) => childrenRef.current.children[0].getBoundingClientRect().height;

const SlideInChoiceSelector = React.memo(({ className, style, currentSlideId, children, lengthRef, gap }) => {
    const childrenRef = useRef();
    const parentRef = useRef();
    const isIn = !!currentSlideId;
    if (!isIn) return "";

    return <SwitchTransition>
        <Transition
            key={currentSlideId}
            nodeRef={parentRef}
            timeout={400}
            appear={true}
            onEnter={(isAppearing) => {
                if (isAppearing) {
                    parentRef.current.style.opacity = 0;
                }
                const length = lengthRef.current;
                const typeCardHeight = calculateHeight(childrenRef);
                parentRef.current.style.minHeight = `${length * typeCardHeight + (length - 1) * gap}px`;

                _.map(childrenRef.current.children, (el, index) => {
                    el.style.top = `${zwoopOffset * index}px`;
                    el.style.position = "absolute";
                    el.style.transition = "top 400ms cubic-bezier(0.25, 0.8, 0.25, 1)"
                })
            }}
            onEntering={(isAppearing) => {
                let last = parentRef.current;
                setTimeout(() => {
                    if (parentRef.current && last === parentRef.current) {
                        const typeCardHeight = calculateHeight(childrenRef);
                        _.map(childrenRef.current.children, (el, index) => {
                            el.style.top = `${index * typeCardHeight + (index * gap)}px`;
                        })
                    }
                }, isAppearing ? 200 : 100)

                if (isAppearing) {
                    setTimeout(() => {
                        parentRef.current.style.opacity = 1;
                    })
                }
            }}
            onEntered={() => {
                _.map(childrenRef.current.children, (el) => {
                    el.style.position = `initial`;
                })
            }}

            onExiting={() => {
                _.map(childrenRef.current.children, (el, index) => {
                    el.style.top = `${zwoopOffset * index}px`;
                    el.style.position = "absolute";
                })
                const length = lengthRef.current;
                const typeCardHeight = calculateHeight(childrenRef);
                parentRef.current.style.minHeight = `${length * typeCardHeight + (length - 1) * gap}px`;
            }}
        >
            <div className={className} style={style} ref={parentRef}>
                {children({ childrenRef })}
            </div>
        </Transition>
    </SwitchTransition>
})

export default SlideInChoiceSelector;